import { createApp } from 'vue';
import SrcLinkModalApp from './SrcLinkModalApp.vue';
import Cookie from 'js-cookie';
import { theme } from '../../Theme';
import { dispatchGtmEvent } from '../../gtm';
const cookieKeyBase = 'skp_skipcmodal';
const fakeAnchorClass = '__target__';
export function initArticleSrcLinkComponent() {
    document.body.addEventListener('click', onClick);
    function onClick(event) {
        var _a, _b;
        const target = event.target;
        // #skpext=true is added by the back-end to external links
        const srcLinkEl = (_a = target.closest) === null || _a === void 0 ? void 0 : _a.call(target, '.articleSrcLink.is--external, a[href*="/extern/"], a[href*="/extern-premium"], a[href*="/extern-locked"]');
        const beforeRedirect = () => {
            if ((srcLinkEl === null || srcLinkEl === void 0 ? void 0 : srcLinkEl.href) !== window.location.href && (srcLinkEl === null || srcLinkEl === void 0 ? void 0 : srcLinkEl.href)) {
                const bareUrl = (srcLinkEl.href || '').replace(/^(https?:\/\/[^\/]+\/)extern[^\/]*?\//, '$1');
                //theme().reportPageView(bareUrl);
                dispatchGtmEvent('SKP.ExternalArticle.visit', {
                    externUrl: srcLinkEl.href || '',
                    articleUrl: bareUrl,
                });
            }
        };
        if (target.classList.contains(fakeAnchorClass) || !srcLinkEl) {
            beforeRedirect();
            return;
        }
        const browsingRestrictions = ((_b = srcLinkEl.href.match(/\/(extern(-(premium|locked))*?)\//)) === null || _b === void 0 ? void 0 : _b[1].split('-').slice(1)) || [];
        const cookieKey = browsingRestrictions.length ? `${cookieKeyBase}_${browsingRestrictions.join('_')}` : cookieKeyBase;
        if (Cookie.get(cookieKey) === 'true') {
            beforeRedirect();
            return;
        }
        // Prevent default behavior and begin modal initialization instead
        event.preventDefault();
        const mountEl = document.createElement('div');
        document.body.appendChild(mountEl);
        const app = createApp(SrcLinkModalApp, {
            srcTitle: srcLinkEl.dataset.srcTitle || '',
            browsingRestrictions,
            setSkipModal: (stat) => {
                if (stat) {
                    const expDate = new Date((new Date().getTime() + (theme().json.popupExpireInSec * 1000)));
                    Cookie.set(cookieKey, 'true', { expires: expDate });
                }
                else {
                    Cookie.remove(cookieKey);
                }
            },
            navigateForward: () => {
                var _a;
                const fakeAnchor = document.createElement('a');
                fakeAnchor.href = srcLinkEl.href;
                fakeAnchor.target = '_blank';
                fakeAnchor.referrerPolicy = 'origin-when-cross-origin';
                fakeAnchor.classList.add(fakeAnchorClass);
                document.body.appendChild(fakeAnchor);
                try {
                    // This will trigger the click event listener again, but this time
                    // redirectImmediately will be true, so it will redirect immediately
                    fakeAnchor.click();
                }
                catch (err) {
                    console.warn(err);
                }
                (_a = fakeAnchor.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(fakeAnchor);
            },
            destroy: () => {
                var _a;
                // Clean up after ourselves
                app.unmount();
                (_a = mountEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(mountEl);
            },
        });
        app.mount(mountEl);
    }
}
